import React from "react";
import {Container, Nav, Navbar} from 'react-bootstrap';

import Logo from '../img/lac_logo.svg';
import {deleteToken} from "../services/AuthService";

const Header = () => {
    return (
        <header>
            <Navbar bg="light" expand="lg" className="mb-3 navbar navbar-expand-lg">
                <Container fluid="lg">
                    <Navbar.Brand href="/fe">
                        <img src={Logo} alt="Logo LAC" className={'img-fluid me-3'} width={40}/>
                        Gestionale clienti
                    </Navbar.Brand>
                    <Nav className="ms-auto">
                        <Nav.Link href="#home" onClick={() => deleteToken()}>Logout</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
        </header>
    );
}
export default Header;